var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGreenCheck(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "144px",
    height: "144px",
    viewBox: "0 0 144 144",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "27BA13B6-3AB0-4441-80E4-168F4C70D4A4") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u21B3-all-appointments",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "create-appointment-wizard---request-submitted",
    transform: "translate(-568.000000, -251.000000)",
    fill: "#1ABA6B",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(568.000000, 251.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    opacity: 0.1,
    cx: 72,
    cy: 72,
    r: 72
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    opacity: 0.2,
    cx: 72,
    cy: 72,
    r: 56
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    opacity: 0.4,
    cx: 72,
    cy: 72,
    r: 40
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.736902,42.288987 C118.00621,45.1782906 111.166436,49.4115211 104.702466,54.1236302 C101.945866,56.13255 99.2575306,58.2286021 96.6754614,60.3455659 C81.4912901,72.7915983 69.9771898,85.9318302 69.7984366,86.1381593 C68.7639199,87.3259453 67.2629559,88 65.6956983,88 C65.524616,88 65.3529707,87.9916353 65.1804808,87.975603 C63.431655,87.8104003 61.8722091,86.8143051 60.9981481,85.3051755 C55.4658766,75.7547899 47.5409158,67.3238788 47.4620955,67.2395348 C45.4177639,65.0765652 45.5309977,61.6818252 47.7154465,59.656873 C49.8998954,57.633315 53.3278755,57.7448442 55.3709403,59.9084411 C55.6580011,60.2124279 61.1466399,66.0517488 66.4789752,73.8016347 C71.9378452,68.0439393 81.4793263,58.5325192 92.7632994,49.652006 C95.1680228,47.7587976 97.6522704,45.8948657 100.192818,44.1020337 C106.694087,39.5133038 113.56553,35.3902084 120.428527,32.4443734 C123.173163,31.2650218 126.361868,32.5140792 127.551914,35.2333704 C128.741256,37.9511281 127.481538,41.1102627 124.736902,42.288987",
    id: "Fill-4"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenCheck);
export default __webpack_public_path__ + "static/media/greenCheck.25952b80ad1f83433b9428223d96ac4c.svg";
export { ForwardRef as ReactComponent };